import React, { useEffect, useState } from 'react';
import { executionOperationsService } from '../../services/executionOperationsService';

export const OperationsMigrationPage: React.FC = () => {
  const [status, setStatus] = useState<Record<string, unknown> | null>(null);
  const [parity, setParity] = useState<Record<string, unknown> | null>(null);

  useEffect(() => {
    void (async () => {
      const [s, p] = await Promise.all([
        executionOperationsService.getMigrationStatus(),
        executionOperationsService.getMigrationParity(),
      ]);
      setStatus(s.data || null);
      setParity(p.data || null);
    })();
  }, []);

  return (
    <div className="space-y-4">
      <div className="rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-900">
        Phase 4 physical queue split is <strong>active by default</strong>. Dedicated workers are defined in{' '}
        <code className="rounded bg-emerald-100 px-1">Procfile.phase4</code>. Set{' '}
        <code className="rounded bg-emerald-100 px-1">EXECUTION_PHYSICAL_QUEUE_MIGRATION_ENABLED=false</code> to
        revert to legacy <code className="rounded bg-emerald-100 px-1">celery</code> routing only.
      </div>
      <Panel title="Migration status" data={status} />
      <Panel title="Routing parity" data={parity} />
    </div>
  );
};

const Panel: React.FC<{ title: string; data: unknown }> = ({ title, data }) => (
  <div className="rounded-xl border border-enterprise-200 bg-white p-4 shadow-sm">
    <h2 className="mb-3 font-semibold text-enterprise-900">{title}</h2>
    <pre className="max-h-[28rem] overflow-auto rounded bg-enterprise-50 p-3 text-xs">{JSON.stringify(data, null, 2)}</pre>
  </div>
);
